export default function getTextFromConsole(key: string) {
	if (window.BUYANDSHIP.content && window.BUYANDSHIP.content.strings) {
		return window.BUYANDSHIP.content.strings[key] || ''
	}
	return ''
}
